import React, { useEffect, useState } from "react";

const usePageReload = () => {
  const [isReloaded, setIsReloaded] = useState(() => {
    // Inicializa o estado a partir do sessionStorage
    return sessionStorage.getItem("reload_detected") === "true";
  });

  useEffect(() => {
    // 1. Verificação usando PerformanceNavigationTiming (abordagem preferida)
    let reloadDetected = false;

    try {
      const navEntries = performance.getEntriesByType("navigation");
      // console.log("navEntries", navEntries);
      if (navEntries.length > 0) {
        const navEntry = navEntries[0];
        if (navEntry.type === "reload") {
          reloadDetected = true;
        }
      }
    } catch (e) {
      console.log("PerformanceNavigationTiming não suportado", e);
    }

    // 2. Fallback para sessionStorage (só se necessário)
    if (!reloadDetected) {
      reloadDetected = sessionStorage.getItem("reload_flag") === "true";
    }

    // Se recarregamento foi detectado, atualiza estado e sessionStorage
    if (reloadDetected) {
      setIsReloaded(true);
      sessionStorage.setItem("reload_detected", "true");
    }

    // Configurar flag para futuras recargas (só se a API não for suportada)
    const beforeUnloadHandler = () => {
      if (!window.performance?.getEntriesByType) {
        sessionStorage.setItem("reload_flag", "true");
      }
    };

    window.addEventListener("beforeunload", beforeUnloadHandler);

    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    };
  }, []);

  return isReloaded;
};

export default usePageReload;
